import 'sentry';
import './mainPublic';
import bootstrap from 'bootstrap';

bootstrap();
